import { render } from "./property-scheme.vue?vue&type=template&id=1aba9c54"
import script from "./property-scheme.vue?vue&type=script&lang=js"
export * from "./property-scheme.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__